module.exports = __webpack_public_path__ + "assets/img/37_1481_big.6445257e.jpg";